import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
// import logo from "./logo.svg";
// import "./App.css";
import Home from "./pages/home";
import Travel from "./pages/travel";
import Guides from "./pages/guides";
import Food from "./pages/food";
import Hotels from "./pages/hotels";
import Privacy from "./pages/privacy";

import DetailsPage from "./pages/detailspage";
import MorePage from "./pages/morepage";
import Search from "./pages/search";
import AIPlanner from "./pages/ai-planner";
import TestAnswer from "./pages/ai-planner/test-answer";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/travel" element={<Travel />} />

          <Route path="/guides" element={<Guides />} />

          <Route path="/food" element={<Food />} />

          <Route path="/hotels" element={<Hotels />} />

          <Route path="/privacy" element={<Privacy />} />

          <Route path="/detailspage" element={<DetailsPage />} />

          <Route path="/morepage" element={<MorePage />} />

          <Route path="/search" element={<Search />} />

          <Route path="/ai-planner" element={<AIPlanner />} />

          <Route path="/ai-planner/test-answer" element={<TestAnswer />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
